import React from 'react';
import './Factorycover.css';


// Images import
import Factor1 from '../../imgs/Factory1.webp';
import Factor2 from '../../imgs/Factory2.webp';
import Factor3 from '../../imgs/Factory3.webp';
import Factor4 from '../../imgs/Factory4.webp';


const cards = [
  { id: 1, img: Factor1 },
  { id: 2, img: Factor2 },
  { id: 3, img: Factor3 },
  { id: 4, img: Factor4 },
];

function Factorycover() {
  return (
    <div className="container">
      {cards.map((Factor) => (
        <div className="Facto" key={Factor.id}>
          <img src={Factor.img} alt={Factor.title} />
        </div>
      ))}
    </div>
  );
}

export default Factorycover;
